import { useCallback } from 'react';
import axiosInstance from '../../../axiosInstance';

/**
 * useRequestApi Hook
 *
 * Pure API hook for request operations.
 *
 * @returns {Object} - { getRequest, getSubmittedForms }
 */
const useRequestApi = () => {
  const getRequest = useCallback(async (requestId) => {
    const response = await axiosInstance.get(`/api/requests/${requestId}`);
    return response.data;
  }, []);

  const getSubmittedForms = useCallback(async (requestId) => {
    const response = await axiosInstance.get(
      `/api/requests/${requestId}/submitted-forms`
    );
    return response.data;
  }, []);

  return { getRequest, getSubmittedForms };
};

export default useRequestApi;
